import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import axios from "axios";
import {Button} from "reactstrap";
import { baseUrl } from "..";
import "../Styles/discountList.css";
import DiscountRules from "./DiscountRules.js"
import { Select, MenuItem } from "@mui/material";
import "../Styles/discountList.css";
import { TiArrowSortedDown } from "react-icons/ti";
import {Box, Typography } from "@mui/material";
import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { toast } from "react-toastify";
import dayjs from 'dayjs';
import { useUser } from "../Context/userContext.js";


const getLiveStatus = (row) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const start = new Date(row.startDate);
  const end = new Date(row.endDate);

  if (today > end) return "expired";

  if (row.status !== "active") return "inactive";  

  // if (today < start) return "upcoming";
  
  return "live";
};
const column = [
  { field: "hostelId", headerName: "hostel id", flex: 1 },
  { field: "discount", headerName: "Discount in %", flex: 1 },

  {
    field: "startDate",
    headerName: "Start",
    flex: 1,
  },
  { field: "endDate", headerName: "end", flex: 1 },
  { field: "daysExclusion", headerName: "Days Excluded", flex: 1 },
  {
    field: "status",
    headerName: "Status",
    flex: 1,
    editable: (params) => params.value === "active",
    type: "singleSelect",
    valueOptions: ["active", "inactive"],
    
    renderCell: (params) => (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "5px 10px",
          borderRadius: "5px",
          width: "100%",
        }}
      >
        {params.value}
      { params.value ==="active" && <TiArrowSortedDown size={22} />}
      </div>
    ),
  
    
    // Show dropdown when editing
    renderEditCell: (params) => {
      if (params.value === "inactive") {
        return <span style={{marginLeft:"22px"}}> inactive</span>;
      }
  
      return (
        <Select
          value={params.value}
          onChange={(event) =>
            params.api.setEditCellValue({
              id: params.id,
              field: "status",
              value: event.target.value,
            })
          }
          displayEmpty
          fullWidth
          sx={{}}
          IconComponent={() => <TiArrowSortedDown style={{marginRight:"20px" ,fontSize:"50px"}} />}
        >
          <MenuItem value="inactive">inactive</MenuItem>
        </Select>
      );
    },
  }
,

{
  field: "liveStatus",
  headerName: "Live/Expired",
  flex: 1,
  sortable: false,
  filterable: false,
  renderCell: (params) => {
    const status = getLiveStatus(params.row);

    const styles = {
      live: {
        bg: "rgba(34, 197, 94, 0.2)",   
        color: "#15803d",              
        dot: "#16a34a",
        label: "Live",
      },
      expired: {
        bg: "rgba(239, 68, 68, 0.2)",
        color: "#b91c1c",
        dot: "#dc2626",
        label: "Expired",
      },
      upcoming: {
        bg: "rgba(245, 158, 11, 0.25)",
        color: "#b45309",
        dot: "#d97706",
        label: "Upcoming",
      },
    inactive: {
  bg: "rgba(107, 114, 128, 0.2)", 
  color: "#374151",               
  dot: "#6b7280",                 
  label: "Inactive",
}
    };

    const { bg, color, dot, label } = styles[status];

    return (
      <div
        style={{
          background: bg,
          color,
          padding: "4px 12px",
          borderRadius: "999px",
          fontWeight: 600, 
          fontSize: "12px",
          width: "100%",
          height: "2rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "8px",
          marginTop: "0.5rem",
        }}
      >
        <span
          style={{
            width: "7px",
            height: "7px",
            borderRadius: "50%",
            backgroundColor: dot,
            boxShadow: `0 0 6px ${dot}`, 
          }}
        />
        {label}
      </div>
    );
  },
},
  {
    field: "created_at",
    headerName: "Created At",
    flex: 1,
  },
  { field: "dealType", headerName: "Deal", flex: 1 },
  { field: "inventoryMoreThan", headerName: "Inventory More than", flex: 1 },
  { field: "daysStart", headerName: "Start days", flex: 1 },

  
];

const mobileColumns = [
  { field: "discount", headerName: "Discount%", flex: 1 },
  { field: "dealType", headerName: "Deal Type", flex: 1 },
  {
    field: 'period',
    headerName: 'Period',
    flex: 1,
    renderCell: (params) => {
      const start = dayjs(params.row.startDate).format('DD-MM-YYYY');
      const end = dayjs(params.row.endDate).format('DD-MM-YYYY');
      return (
        <div style={{ whiteSpace: 'normal', lineHeight: '1.5', padding: '4px 0' }}>
        <div><strong>Start</strong>&nbsp; {start}</div>
        <div><strong>End</strong>&nbsp;&nbsp;&nbsp; {end}</div>
      </div>
      );
    },
  },
  { field: "daysStart", headerName: "Days", flex: 1 },
];

const DiscountList = (props) => {
  const [discountList, setDiscountList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [discountStatusFilter, setDiscountStatusFilter] = useState("all");
  const [dialogBox, setDialogBox] = useState(null);
  const [isLaptop, setIsLaptop] = useState(window.matchMedia("(min-width: 1024px)").matches);
  const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 768px)").matches);
  const [selectedRow, setSelectedRow] = useState(null);
  const [open, setOpen] = useState(false);
 
  const { selectedHostelId,role  } = useUser();
  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1024px)");
    mediaQuery.addEventListener("change", handleResize);
    const mediaQueryList = window.matchMedia("(max-width: 768px)");
    mediaQueryList.addEventListener("change", updateScreenSize);
    fetchDiscounts();
  }, [selectedHostelId]);

  const fetchDiscounts = async () => {
    if(!selectedHostelId) return;
    const token = localStorage.getItem("token");
    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const res = await axios.get(`${baseUrl}/discount-rules`,{
      params: { hostelId: selectedHostelId },
    ...headers
    });
    console.log("discount list",res?.data)
    if (res.status === 200) {
      const data = res.data.map((i) => {
      const excludedDays = i?.daysExclusion ? JSON.parse(i.daysExclusion) : [];
        return {
          ...i,
          created_at: i.created_at.split("T")[0],
          daysExclusion: excludedDays?.join(","),
        };
      });
      setDiscountList(data);
      setFilteredData(data);
    }
  };
  const handleResize = (event) => {
    setIsLaptop(event.matches);
  };

  const updateScreenSize = (event) => {
    setIsMobile(event.matches);
  };

  const filterActiveStatusDiscounts = () => {
    if (discountStatusFilter === "active")
      {
        setFilteredData(discountList);
        setDiscountStatusFilter("all");
      }
    else
    {
      const filterItems = discountList.filter(
        (item) => item.status === "active"
      );
      setFilteredData(filterItems);
      setDiscountStatusFilter("active");
    }
  };

  const filterInactiveStatusDiscounts = () => {
    if (discountStatusFilter === "inactive")
      {
        setFilteredData(discountList);
        setDiscountStatusFilter("all");
      }
    else
    {
      const filterItems = discountList.filter(
        (item) => item.status === "inactive"
      );
      setFilteredData(filterItems);
      setDiscountStatusFilter("inactive");
    }
  };

  const filterDataFunction = (e) => {
    if (e.target.value === "all") { 
      setFilteredData(discountList);
    } else {
      const filterItems = discountList.filter(
        (item) => item.status === e.target.value
      );
      setFilteredData(filterItems);
    }
  };

  const handleStatusChange = async (updatedRow) => { 
    console.log(updatedRow.status)
    if(role == 'employee'){
      console.error("role = employee, don't have access to edit");
      return;
    }
    try {      
   const token = localStorage.getItem("token");
   const headers = { 
     headers: { Authorization: `Bearer ${token}` },  
   };
   const res = await axios.put(`${baseUrl}/discount-rules/change-status/${updatedRow.id}`,{status:updatedRow.status},headers)
   console.log(res)
   if(res.status === 200){
    toast.success(`Discount rule is now ${updatedRow.status} `,{
     autoClose:1000
    })
   }
 } catch (error) { 
   console.error("Error updating status:", error);
 } 
}; 
const handleClose=()=>{
  setOpen(false);
}
  return (
    <div>

    {isMobile && (
      <div className="m-5  main-container">
        <DiscountRules dialogBox={dialogBox} setDialogBox={setDialogBox} />
        <div className="d-flex gap-4">
          <button style={{ fontSize: "0.7rem" }} className="px-4 py-2 rounded shadow transition cursor-pointer" onClick={filterActiveStatusDiscounts}>
            Active
          </button>
          <button style={{ fontSize: "0.7rem" }} className="px-4 py-2 rounded shadow transition cursor-pointer" onClick={filterInactiveStatusDiscounts}>
            Inactive
          </button>
        </div>
        {!dialogBox && <DataGrid
          rows={filteredData}
          columns={mobileColumns}
          rowsPerPageOptions={[1, 2, 4, 100]}
          pagination
          autoHeight
          processRowUpdate={handleStatusChange}
          onRowClick={(params) => {
            setSelectedRow(params.row);
            setOpen(true); // show the paper
          }}
          sx={{
            borderRadius: 0, // Removes rounded corners
            "& .MuiDataGrid-columnHeaders": {
              borderRadius: 0, // Removes rounded corners for header
            },
            "& .MuiDataGrid-footerContainer": {
              borderRadius: 0,
              display: "flex",
              justifyContent: "space-between", // Proper spacing for footer
              alignItems: "center",
              padding: "8px 16px",
              minHeight: "40px",
            },
            "& .MuiTablePagination-root": {
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-between",
            },
            "& .MuiTablePagination-toolbar": {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            },
            "& .MuiTablePagination-selectLabel": {
              display: "flex",
              alignItems: "center",
              marginRight: "8px", // Adds spacing between "Rows per page" and the select
              marginTop: "14px",
            },
            "& .MuiSelect-select": {
              paddingRight: "32px !important", // Space for dropdown arrow
              paddingLeft: "8px", // Adds spacing between number and arrow
              height: "32px !important",
              display: "flex",
              alignItems: "center",
              lineHeight: "normal",
              textAlign: "center",
            },
            "& .MuiSelect-icon": {
              right: "8px", // Positions the arrow properly
              top: "50%", // Centers it vertically
              transform: "translateY(-50%)",
              marginLeft: "4px", // Space between number and arrow
            },
            "& .MuiTablePagination-displayedRows": {
              marginTop: "14px", // Moves "1-2 of 2" slightly downward
            },
            "& .MuiTablePagination-actions": {
              display: "flex",
              alignItems: "center",
            },
          }}
        />}
        {selectedRow &&(
        <Dialog
          fullScreen
          open={open}
          // onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
      <Typography variant="h4" sx={{ mt: 1, fontWeight: 'bold', textAlign: 'center' }}>
      {selectedRow.customerName}
    </Typography>
            <Paper 
            elevation={5}
            sx={{
                borderRadius: 6,
                padding: 1,
                mt: 7,
                ml: 4,
                mr: 4,
                mb: 4,
              }}>
          <Typography sx={{ fontSize: '30px', textAlign: 'center' }}><strong>Discount Summary</strong></Typography>
          <hr style={{ borderTop: '2px solid #000000' }}></hr>
          <DialogContent>
              <Box>

                <Typography>Hostel Id: <strong>{selectedRow.id}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Discount % : <strong>{selectedRow.discount}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Created At: <strong>{selectedRow.created_at}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Start Date: <strong>{selectedRow.startDate}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>End Date: <strong>{selectedRow.endDate}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Days Excluded: <strong>{selectedRow.daysExclusion}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Status <strong>{selectedRow.status}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Deal Type: <strong>{selectedRow.dealType}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Inventory More Than: <strong>{selectedRow.inventoryMoreThan}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Days: <strong>{selectedRow.daysStart}</strong></Typography>
              </Box>
          </DialogContent>
          </Paper>
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
</Dialog>
        )}
      </div>
    )}

    {isLaptop && (
      <div className="m-5  main-container">
        <DiscountRules dialogBox={dialogBox} setDialogBox={setDialogBox} />

        <div className="filter-select">
          <select
            onChange={(e) => {
              filterDataFunction(e);
            }}
          >
            <option value="all">All</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>



        <DataGrid
          rows={filteredData}
          columns={column}
          rowsPerPageOptions={[1, 2, 4, 100]}
          pagination
          autoHeight
          processRowUpdate={handleStatusChange}
          sx={{
            borderRadius: 0, // Removes rounded corners
            "& .MuiDataGrid-columnHeaders": {
              borderRadius: 0, // Removes rounded corners for header
            },
            "& .MuiDataGrid-footerContainer": {
              borderRadius: 0,
              display: "flex",
              justifyContent: "space-between", // Proper spacing for footer
              alignItems: "center",
              padding: "8px 16px",
              minHeight: "40px",
            },
            "& .MuiTablePagination-root": {
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-between",
            },
            "& .MuiTablePagination-toolbar": {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            },
            "& .MuiTablePagination-selectLabel": {
              display: "flex",
              alignItems: "center",
              marginRight: "8px", // Adds spacing between "Rows per page" and the select
              marginTop: "14px",
            },
            "& .MuiSelect-select": {
              paddingRight: "32px !important", // Space for dropdown arrow
              paddingLeft: "8px", // Adds spacing between number and arrow
              height: "32px !important",
              display: "flex",
              alignItems: "center",
              lineHeight: "normal",
              textAlign: "center",
            },
            "& .MuiSelect-icon": {
              right: "8px", // Positions the arrow properly
              top: "50%", // Centers it vertically
              transform: "translateY(-50%)",
              marginLeft: "4px", // Space between number and arrow
            },
            "& .MuiTablePagination-displayedRows": {
              marginTop: "14px", // Moves "1-2 of 2" slightly downward
            },
            "& .MuiTablePagination-actions": {
              display: "flex",
              alignItems: "center",
            },
          }}
        />
      </div>
    )}

    </div>
  );
};

export default DiscountList;
